import { render, staticRenderFns } from "./classQuestionDetail.vue?vue&type=template&id=0d72ec7c&scoped=true"
import script from "./classQuestionDetail.vue?vue&type=script&lang=js"
export * from "./classQuestionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72ec7c",
  null
  
)

export default component.exports